import { anyType, functionType, objectType, stringType } from '../_util/type';
export const qrProps = () => {
    return {
        size: { type: Number, default: 160 },
        value: { type: String, required: true },
        type: stringType('canvas'),
        color: String,
        bgColor: String,
        includeMargin: Boolean,
        imageSettings: objectType(),
    };
};
export const qrcodeProps = () => {
    return Object.assign(Object.assign({}, qrProps()), { errorLevel: stringType('M'), icon: String, 
        /** Include image size. Object form since 4.26.0 (antd ≥ 5.19). */
        iconSize: anyType(40), status: stringType('active'), 
        /** Custom status overlay render (antd ≥ 5.20). Also available as `statusRender` slot. */
        statusRender: functionType(), bordered: { type: Boolean, default: true } });
};
